import Helpers from "commons/helpers";
import { ICodename } from "commons/interfaces";
import { AllGroupCodeName, BooleanInt, GeographySource, GeographyType, Status } from "constants/enum";

import Constants from "constants/index";
import UserService from 'services/identity/user.service';
import SearchService from "services/search/search.service";
import ReportService from 'services/medkit/report.service';
import GroupService from "services/identity/group.service";
import ProjectService from "services/medkit/project.service";
import CodenameService from "services/common/codename.service";
import OrganizationService from "services/identity/organization.service";



const userService = new UserService();
const groupService = new GroupService();
const reportService = new ReportService();
const searchService = new SearchService();
const projectService = new ProjectService();
const codeNameService = new CodenameService();
const organizationService = new OrganizationService();

const useDataCommon = () => {

    const getDataOrganizations = async (req: any) => {
        try {
            const items: ICodename[] = [];
            const selectedItems: ICodename[] = [];
            const lang = req.language || Constants.DefaultLanguage;

            const result = await organizationService.getPaged(req);

            for (const el of [...result.items || []]) {
                const name = Helpers.getDefaultValueMultiLanguage(el.name, lang, true);
                items.push({
                    name: name,
                    code: el.id,
                });
            };

            for (const el of [...result.selectedItems || []]) {
                const name = Helpers.getDefaultValueMultiLanguage(el.name, lang, true);
                selectedItems.push({
                    name: name,
                    code: el.id,
                });
            };

            return ({
                items: items || [],
                hasNext: result.hasNext,
                currentPage: result.currentPage,
                selectedItems: selectedItems || [],
            });
        } catch (error) {
            return ({
                items: [],
                hasNext: false,
                currentPage: 0,
                selectedItems: [],
            });
        }
    };

    const getDataDepartments = async (req: any) => {
        try {
            const items: ICodename[] = [];
            const selectedItems: ICodename[] = [];
            const lang = req.language || Constants.DefaultLanguage;

            const result = await groupService.getPaged({ ...req, nonHierarchical: BooleanInt.False });

            for (const element of [...result.items || []]) {
                // if (Helpers.isNullOrEmpty(element.parentGroup) || (element.parentGroup === "0")) {
                //     for (const item of [...element?.childs || []]) {
                //         const name = Helpers.getDefaultValueMultiLanguage(item.name, lang, true);
                //         items.push({
                //             name: name,
                //             code: item.id,
                //         });
                //     }
                // } else {
                const name = Helpers.getDefaultValueMultiLanguage(element.name, lang, true);
                items.push({
                    code: element.id,
                    name: `[${element.groupCode}] - ${name}`,
                });
                // }
            };

            return ({
                items: items || [],
                hasNext: result.hasNext,
                currentPage: result.currentPage,
                selectedItems: selectedItems || [],
            });
        } catch (error) {
            return ({
                items: [],
                hasNext: false,
                currentPage: 0,
                selectedItems: [],
            });
        }
    };

    const getAllDepartments = async (req: {
        clientId: string;
        language?: string;
        organizationId: string;
    }) => {
        try {
            const items: ICodename[] = [];
            const lang = req.language || Constants.DefaultLanguage;

            const result = await groupService.getAll({
                clientId: req.clientId,
                listStatus: [Status.Active],
                nonHierarchical: BooleanInt.False,
                organizationId: req?.organizationId,
            });

            for (const element of [...result || []]) {
                const name = Helpers.getDefaultValueMultiLanguage(element.name, lang, true);
                items.push({
                    code: element.id,
                    name: `[${element.groupCode}] - ${name}`,
                });
            };

            return items;
        } catch (error) { return []; }
    };

    const getDataUsers = async (req: any, includeGroupName?: boolean) => {
        try {
            const items: ICodename[] = [];
            const selectedItems: ICodename[] = [];

            const result = await userService.getPaged({ ...req, nonHierarchical: BooleanInt.False, });

            for (const element of result?.items ?? []) {
                let fullName = element.fullName || element.userName;
                const lastName = element.organizationUserProfile?.lastName;
                const firstName = element.organizationUserProfile?.firstName;
                if (
                    !Helpers.isNullOrEmpty(lastName) ||
                    !Helpers.isNullOrEmpty(firstName)
                ) {
                    fullName = `${lastName || ""} ${firstName || ""}`.trim();
                }

                if (includeGroupName && element?.groupUsers?.[0]?.groupName) {
                    const groupName = Helpers.getDefaultValueMultiLanguage(element.groupUsers[0].groupName, Constants.LanguageContent.VI);
                    fullName += ` (${groupName})`;
                }

                items.push({
                    code: element.id,
                    name: fullName,
                    detail: {
                        avatarId: element.avatarId || element.avatarId,
                        avatarUrl: element.avatarUrl || element.avatarUrl,
                        email: element.organizationUserProfile?.email || element.email,
                        phoneNumber: element.organizationUserProfile?.phoneNumber || element.phoneNumber,
                    },
                });
            };

            for (const element of result?.selectedItems ?? []) {
                let fullName = element.fullName || element.userName;
                const lastName = element.organizationUserProfile?.lastName;
                const firstName = element.organizationUserProfile?.firstName;
                if (
                    !Helpers.isNullOrEmpty(lastName) ||
                    !Helpers.isNullOrEmpty(firstName)
                ) {
                    fullName = `${lastName || ""} ${firstName || ""}`.trim();
                }

                if (includeGroupName && element?.groupUsers?.[0]?.groupName) {
                    const groupName = Helpers.getDefaultValueMultiLanguage(element.groupUsers[0].groupName, Constants.LanguageContent.VI);
                    fullName += ` (${groupName})`;
                }

                selectedItems.push({
                    code: element.id,
                    name: fullName,
                    detail: {
                        avatarId: element.avatarId || element.avatarId,
                        avatarUrl: element.avatarUrl || element.avatarUrl,
                        email: element.organizationUserProfile?.email || element.email,
                        phoneNumber: element.organizationUserProfile?.phoneNumber || element.phoneNumber,
                    },
                });
            };

            return ({
                items: items,
                hasNext: result.hasNext,
                currentPage: result.currentPage,
                selectedItems: selectedItems || [],
            });
        } catch (error) {
            return ({
                items: [],
                hasNext: false,
                currentPage: 0,
                selectedItems: [],
            });
        }
    };

    const getDataReferenceReports = async (req: any) => {
        try {
            const items: ICodename[] = [];
            const selectedItems: ICodename[] = [];
            const result = await reportService.getPaged({ ...req });

            for (const el of [...result.items || []]) {
                items.push({
                    code: el.id,
                    name: `[${el.reportNo}] - ${el.shortDescription || ""}`,
                    group: "reference_report",
                });
            };

            return ({
                items: items || [],
                hasNext: result.hasNext,
                currentPage: result.currentPage,
                selectedItems: selectedItems || [],
            });
        } catch (error) {
            return ({
                items: [],
                hasNext: false,
                currentPage: 0,
                selectedItems: [],
            });
        }
    };

    const getDataCommonCodename = async (workingOrganization?: string) => {
        try {

            let stringGroups: string[] = [];
            for (let val in AllGroupCodeName) {
                stringGroups.push(val);
            };

            const groups: any = await codeNameService.getByGroup({
                group: stringGroups.join(","),
                serviceCode: Constants.SERVICE_CODE,
                organizationId: workingOrganization || "0",
                includeCommon: BooleanInt.True,
            });

            return groups;
        } catch (error) {
            return undefined;
        }
    };

    const getDataProjects = async (req: any) => {
        try {
            const items: ICodename[] = [];
            const selectedItems: ICodename[] = [];

            const result = await projectService.getPaged(req);

            for (const el of [...result.items || []]) {
                items.push({
                    code: el.id,
                    name: el.name,
                });
            };

            for (const el of [...result.selectedItems || []]) {
                selectedItems.push({
                    code: el.id,
                    name: el.name,
                });
            };

            return ({
                items: items || [],
                hasNext: result.hasNext,
                currentPage: result.currentPage,
                selectedItems: selectedItems || [],
            });
        } catch (error) {
            return ({
                items: [],
                hasNext: false,
                currentPage: 0,
                selectedItems: [],
            });
        }
    };

    const getSearchQueryByGeography = async (req: any) => {
        const language = req.language || Constants.DefaultLanguage;
        const valueCity = GeographyType.AdministrativeDivision | GeographyType.City;
        const valueCountry = GeographyType.AdministrativeDivision | GeographyType.Country;
        const valueProvince = GeographyType.AdministrativeDivision | GeographyType.ProvinceState;
        const valueSource = [GeographySource.Origin, GeographySource.Origin | GeographySource.Expedia];

        try {
            const items: ICodename[] = [];
            const selectedItems: ICodename[] = [...(req.selectedItems || [])];

            const result = await searchService.geographyQuery({
                pageSize: req.pageSize,
                pageNumber: req.pageNumber,
                includeFields: ["id", "name", "fullName", "isoCode"],
                geography: {
                    source: valueSource,
                    countryCode: "VN",
                    administrative: 1,
                    fullName: req.searchText,
                    type: [valueProvince],
                },
            });

            for (const item of [...(result?.selectedItems || [])]) {
                selectedItems.push({
                    detail: item,
                    code: item.id,
                    name: Helpers.getDefaultValueMultiLanguage(item.name, language, true),
                });
            }

            for (const item of [...(result?.items || [])]) {
                items.push({
                    detail: item,
                    code: item.id,
                    name: Helpers.getDefaultValueMultiLanguage(item.name, language, true),
                });
            }

            return {
                items: items,
                selectedItems: selectedItems,
                hasNext: result?.hasNext || false,
                currentPage: result?.currentPage || 0,
            };
        } catch (error) {
            return {
                items: [],
                selectedItems: [],
                hasNext: false,
                currentPage: 0,
            };
        }
    };

    return {
        getDataUsers,
        getDataProjects,
        getAllDepartments,
        getDataDepartments,
        getDataOrganizations,
        getDataCommonCodename,
        getDataReferenceReports,
        getSearchQueryByGeography,
    };
};

export default useDataCommon;